<template>
<div class="imgOrVoiceOrVideoMaterial">
  <div
    class="list-outer-material clearfix"
  >
    <div
      v-if="isAuth('wx:wxassets:save')"
      class="add-card-item card-item-new">
      <div class="add-card-item-inner">
        <span
            @click="addHandle"
            :style="btnStyle"
            class="icon-box">+</span>
        <el-button
          @click="addHandle"
          type="text"
          class="btn"
        >新增</el-button>
      </div>
    </div>
    <card-item-new
      v-for="(item,index) in listData"
      :key="index"
      :is-select-mode="isSelectMode"
      :file-type="fileType"
      :item-data="item"
      @delete-success="deleteSuccess"
      @selected="selectedHandle"
      @edit="editHandle"
    ></card-item-new>
  </div>
  <div class="pagination-outer" v-if="total">
    <div class="paginnation-left">
      <size-change @sizeChange="sizeChange"></size-change>
      <span class="tatol-count">合计 {{total}} 条</span>
    </div>
    <vs-pagination
      class="pagination-box"
      :max="max"
      :total="pageSize"
      v-model="page"
    ></vs-pagination>
  </div>
  <add-or-edit-img-text-dialog
    ref="dialog"
    :dialog-show="dialogShow"
    @close="closeDialogShow"
    @add-success="doSuccess"
    @edit-success="editSuccess"
  ></add-or-edit-img-text-dialog>
</div>
</template>

<script>
import addOrEditImgTextDialog from "../../../../components/wx/material/materialNew/addOrEditImgTextDialog";
import { colorRgba } from "@/utils";
import { mapGetters } from 'vuex'
import cardItemNew from "@/components/wx/material/cardItemNew";
import initData from "@/mixins/initData";
export default {
  name: "imgOrTextMaterial",
  components:{
    cardItemNew,
    addOrEditImgTextDialog,
  },
  props: {
    isSelectMode:{
      type: Boolean,
      default: false,
    },
    fileType: {//news
      type: String,
      default: 'news'
    },
  },
  mixins: [initData],
  data() {
    return {
      dialogShow: false,
      size: 20,
    }
  },
  watch:{
    selectedAppid(val){
      if(val){
        this.searchHandle();
      }
    }
  },
  computed: {
    ...mapGetters(['themeColor','selectedAppid']),
    btnStyle(){
      return {
        backgroundColor: colorRgba(this.themeColor,0.5),
      }
    }
  },
  created(){
    this.searchHandle();
  },
  methods: {
    editHandle(news){
      setTimeout(() => {
        this.dialogShow = true;
        let dialog = this.$refs.dialog;
        dialog.$refs.outform.init(news);
      });
    },
    beforeInit(){
      this.url = '/wx/manage/wxAssets/materialNewsBatchGet';
      this.params = {
        page: this.page,
        limit: this.size,
        type: 'news',
      }
      return true;
    },
    addHandle(){
      setTimeout(() => {
        this.dialogShow = true;
        let dialog = this.$refs.dialog;
        dialog.$refs.outform.init();
      },200);
    },
    selectedHandle(itemData){
      this.$emit('selected', itemData);
    },
    closeDialogShow(){
      this.dialogShow = false;
    },
    doSuccess(){
      setTimeout(() => {
        this.dialogShow = false;
        this.searchHandle();
      },200);
    },
    editSuccess(){
      setTimeout(() => {
        this.closeDialogShow();
        this.searchHandle();
      },200);
    },
    searchHandle(){
      this.page = 1;
      this.init().then((res) => {
        this.$emit('send-count',res.data.itemCount);
      });
    },
    deleteSuccess(){
      this.searchHandle();
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/variable";
.imgOrVoiceOrVideoMaterial {
  .card-item-new {
    height: 90px;
    margin-right: 10px;

    &.add-card-item {
      height: 90px;
    }
    &.add-card-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      .icon-box {
        width: 32px;
        height: 32px;
        border-radius: 16px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        font-weight: bold;
        cursor: pointer;
        color: #ffffff;
      }
    }
  }
}
</style>
